// extracted by mini-css-extract-plugin
export var div_table_container = "table_codes_color-module--div_table_container--2a504";
export var table_container = "table_codes_color-module--table_container--f902f";
export var table_row = "table_codes_color-module--table_row--aa97c";
export var th = "table_codes_color-module--th--75164";